// extracted by mini-css-extract-plugin
export var actionButton = "_5j-1";
export var actionButtons = "_5j-2";
export var actions = "_5j-0";
export var aiUnread = "_5j-10";
export var alignCenter = "_5j-h";
export var backWrapper = "_5j-3";
export var cellContainer = "_5j-4";
export var checkboxContainer = "_5j-5";
export var contentContainer = "_5j-6";
export var contentHeader = "_5j-8";
export var conversationsTableWrapper = "_5j-s";
export var draftReplyBadgeContainer = "_5j-m";
export var dropdownItem = "_5j-b";
export var dropdownItemsContainer = "_5j-a";
export var dropdownTitle = "_5j-c";
export var errorIcon = "_5j-7";
export var filter = "_5j-d";
export var gray = "_5j-i";
export var headerActionButtons = "_5j-e";
export var headerCheckboxContainer = "_5j-f";
export var icon = "_5j-j";
export var menuContainer = "_5j-k";
export var noMoreTicketsIcon = "_5j-12";
export var noMoreTicketsSubText = "_5j-13";
export var oneLine = "_5j-l";
export var optionsButton = "_5j-n";
export var plus = "_5j-o";
export var portalButtonsWrapper = "_5j-g";
export var red = "_5j-p";
export var scrolledTop = "_5j-9";
export var search = "_5j-q";
export var selectedConversationsCount = "_5j-r";
export var spinner = "_5j-t";
export var strong = "_5j-u";
export var summaryCell = "_5j-v";
export var tableContainer = "_5j-11";
export var tagContainer = "_5j-w";
export var threeDots = "_5j-x";
export var twoLines = "_5j-y";
export var unread = "_5j-z";